import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

const FilterCell = styled(TableCell, {
	shouldForwardProp: (prop) => {
		return !['isActive', 'isHoverable'].includes(prop);
	},
})(({ theme, isActive, isHoverable }) => ({
	whiteSpace: 'nowrap',
	fontSize: 12,
	textTransform: 'none',
	pt: 1,
	pb: 1,
	zIndex: 1,
	cursor: isHoverable ? 'pointer' : 'default',
	verticalAlign: 'top',
	position: 'relative',
	':before': {
		content: '""',
		position: 'absolute',
		left: 4,
		top: 4,
		bottom: 4,
		right: 4,
		zIndex: -1,
		borderRadius: 4,
	},
	...(isHoverable &&
		!isActive && {
		':hover': {
			color: theme.palette.primary.dark,
			':before': {
				backgroundColor: theme.palette.primary.lighter,
			},
		},
	}),
	...(isActive && {
		color: theme.palette.primary.contrastText,
		'.MuiTypography-root': {
			color: theme.palette.primary.contrastText,
		},
		':before': {
			content: '""',
			position: 'absolute',
			left: 4,
			top: 4,
			bottom: 4,
			right: 4,
			zIndex: -1,
			borderRadius: 4,
			backgroundColor: theme.palette.primary[400],
		},
	}),
}));

export default FilterCell;
